import { defaultPlcTagHistDto, PlcTagHistDto } from "src/dtos/plcTag/plcTagHistDto";

/**
 * EQM1011_R01 설비데이터 수집 조회 목록 1건.
 * 6차 요청으로 plc_tag_hist를 조회하며 필드명은 DB 컬럼명을 따른다. 이력 컬럼은 PlcTagHistDto에서 상속한다.
 */
export interface EQM1011_R01Dto extends PlcTagHistDto {
    compCd: string; // 사업장코드 (plc_master.comp_cd)
    compNm: string; // 사업장명
    plcId: string; // PLC 고유번호 (plc_master.plc_id)
    plcName: string; // PLC명
    tagName: string; // 데이터명 (plc_tag.tag_name)
}

/** 그리드 빈 행 기본값 — 상속 필드(기본값 펼치기)와 화면 필드를 모두 포함 */
export const defaultEQM1011_R01Data: EQM1011_R01Dto = {
    ...defaultPlcTagHistDto,
    compCd: '',
    compNm: '',
    plcId: '',
    plcName: '',
    tagName: '',
};
